export default {
    name: 'PremiumRestrictedAction',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean },
    methods: {
        openSubscriptionModal() {}
    }
};
